import { LabelProps, PanelProps } from "@mcleod/components";
import { AbstractSectionPanel } from "./AbstractSectionPanel";
import { ExpandButton } from "./ExpandButton";
import { PropertyLinePanel } from "./PropertyLinePanel";

export class PropertyLineHeaderPanel extends PropertyLinePanel {
    constructor(sectionPanel: AbstractSectionPanel, props?: Partial<PanelProps>) {
        super(null, null, null, props);
        this.addExpandAllButton(sectionPanel);
    }

    protected override getNameColumnDef(): Partial<LabelProps> {
        const a = { ...super.getNameColumnDef(), text: "Name", fontSize: "large" };
        return a;
    }

    protected override getTypeColumnDef(): Partial<LabelProps> {
        return { ...super.getTypeColumnDef(), text: "Type", fontBold: true, fontSize: "large" };
    }

    protected override getDefaultValueColumnDef(): Partial<LabelProps> {
        return { ...super.getDefaultValueColumnDef(), text: "Default", fontBold: true, fontSize: "large" };
    }

    protected override getDescrColumnDef(): Partial<LabelProps> {
        return { ...super.getDescrColumnDef(), text: "Description", fontBold: true, fontSize: "large" };
    }

    private addExpandAllButton(sectionPanel: AbstractSectionPanel) {
        const expandAllButton = new ExpandButton(sectionPanel, true);
        this.add(expandAllButton);
    }
}
